import React from "react";

const getPercentageColor = (value) => {
  if (value >= 0) return "#22c55e";
  return "#ef4444";
};

const StagePerformance = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <div className="p-6 overflow-x-auto">
      <table className="min-w-full bg-white rounded-lg border border-gray-200 shadow-md">
        <thead>
          <tr className="bg-gradient-to-r from-gray-100 to-gray-50 text-left border-b-2 border-gray-200">
            <th className="p-4 font-semibold text-gray-700 text-sm uppercase tracking-wide">
              Stage
            </th>
            <th className="p-4 font-semibold text-gray-700 text-sm uppercase tracking-wide">
              Average Time (hrs)
            </th>
            <th className="p-4 font-semibold text-gray-700 text-sm uppercase tracking-wide">
              Target (hrs)
            </th>
            <th className="p-4 font-semibold text-gray-700 text-sm uppercase tracking-wide">
              % to Target
            </th>
          </tr>
        </thead>

        <tbody>
          {data.map((row, index) => {
            const isTotal = row.stage === "TOTAL";
            const isMeetingTarget = row.percentage_to_target >= 0;
            const percentage = Math.abs(row.percentage_to_target);

            return (
              <tr
                key={index}
                className={`
                  border-t border-gray-100 transition-all duration-200
                  ${
                    isTotal
                      ? "bg-blue-50 font-semibold"
                      : "hover:bg-gray-50 hover:shadow-sm"
                  }
                `}
              >
                <td className="p-4 text-gray-800">
                  <div className="flex items-center gap-2">
                    {isTotal && <span className="text-blue-600">📊</span>}
                    <span>{row.stage}</span>
                  </div>
                </td>

                <td className="p-4 text-gray-700">
                  <span className="font-medium">{row.average}</span>
                </td>

                <td className="p-4 text-gray-700">
                  <span className="font-medium">{row.target}</span>
                </td>

                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <span
                      className="font-bold text-lg"
                      style={{
                        color: getPercentageColor(row.percentage_to_target),
                      }}
                    >
                      {row.percentage_to_target > 0 ? "+" : ""}
                      {row.percentage_to_target}%
                    </span>

                    {/* Progress Bar */}
                    <div className="flex-1 max-w-[100px]">
                      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                        <div
                          className="h-2 rounded-full transition-all duration-300"
                          style={{
                            width: `${Math.min(percentage, 100)}%`,
                            backgroundColor: getPercentageColor(
                              row.percentage_to_target
                            ),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StagePerformance;
